<script setup lang="ts">
defineProps<{
  label: string;
  icon: string;
}>();
</script>

<template>
  <div class="">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center gap-2">
        <el-icon size="1.2rem">
          <i :class="icon"></i>
        </el-icon>
        <small>{{ label }}</small>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
